const Sw = {

  scrollDelay: 1000,

  init: () => {

    console.log('Sw.init')

    const body = $('body')

    Sw.global.init()
    Sw.sections.init()

    body.hasClass('blog-page') && Sw.blog.init()

    body.hasClass('article-page') && Sw.blog.article.init()

    body.hasClass('product-page') && Sw.product.init()

    body.hasClass('cart-page') && Sw.cart.init()
  },

  blog: {

    init: () => {

      console.log('Sw.blog.init')

      const blogContainer = $('.sw-blog-all')
      const paginationContainer = $('.sw-blog-pagination')

      if (blogContainer.length && paginationContainer.length) {

        const params = new URLSearchParams(window.location.search)
        const page = parseInt(params.get('blog_page')) || 1

        Sw.blog.filterBlogArticles(blogContainer, page)
        Sw.blog.appendPagination(paginationContainer, page)
      }
    },

    filterBlogArticles: (container, page) => {

      console.log('Sw.blog.filterBlogArticles')

      if (!container.length) {
        console.error('Container NOT found')
        return
      }

      const articlesCount = parseInt(container.data('articles_to_show'))
      const blogItems = container.find('.blog-item').toArray()

      blogItems.sort((a, b) => Sw.blog.extractArticleTimestamp(b) - Sw.blog.extractArticleTimestamp(a))

      const startIndex = (page - 1) * articlesCount
      const endIndex = startIndex + articlesCount

      container.empty()

      $(blogItems).slice(startIndex, endIndex).appendTo(container)

      container.removeClass('d-none')
    },

    appendPagination: (container, page) => {

      console.log('Sw.blog.appendPagination')

      const totalPages = parseInt(container.data('total_pages'))

      let startPage = page - 2
      let endPage = page + 2

      if (startPage < 2) startPage = 2
      if (endPage > totalPages) endPage = totalPages

      if (page > 1) {
        container.append(`<a href="?blog_page=${page - 1}" class="page-numbers prev" aria-label="Previous page"><i class="feather-chevron-left"></i></a>`)
      }

      container.append(`<a href="?blog_page=1" class="page-numbers ${page === 1 ? 'current' : ''}" aria-label="Page 1">1</a>`)

      if (page > 4) {
        container.append(`<span class="page-numbers">…</span>`)
      }

      for (let i = startPage; i <= endPage; i++) {
        container.append(`<a href="?blog_page=${i}" class="page-numbers ${page === i ? 'current' : ''}" aria-label="Page ${i}">${i}</a>`)
      }

      if (page < totalPages - 3) {
        container.append(`<span class="page-numbers">…</span>`)
      }

      if (page < totalPages - 2) {

        container.append(`<a href="?blog_page=${totalPages}" class="page-numbers ${page === totalPages ? 'current' : ''}" aria-label="Page ${totalPages}">${totalPages}</a>`)
      }

      if (page < totalPages) {

        container.append(`<a href="?blog_page=${page + 1}" class="page-numbers next" aria-label="Next page"><i class="feather-chevron-right"></i></a>`)
      }

      container.removeClass('d-none')
    },

    extractArticleTimestamp: article => {

      const dateText = $(article).find('.blog-meta-wrap .js-sw-article-date').data('date_format').trim()
      return Date.parse(dateText)
    },

    article: {

      init: () => {

        console.log('Sw.article.init')

        $('.article-page .article-content iframe').wrap('<div class="sw-video-wrapper"></div>')

        $(document).on('click', '.article-disclaimer .load-more', function() {

          var parentContainer = $(this).closest('.article-disclaimer')
          var contentHeight = parentContainer.find('.disclaimer-text').outerHeight()
          var hasClass = parentContainer.hasClass('slide-down')

          hasClass ? parentContainer.removeClass('slide-down').height(100) : parentContainer.addClass('slide-down').height(contentHeight)
        })
      }
    },
  },

  global: {

    init: () => {

      $(document).on('click', '.js-sw-close-search', () => {

        $('body').removeClass('search-active')
        $('.search-results-wrapper').removeClass('active')
      })

      $(document).on('click', '.js-scroll-to-section', function (event) {

        event.preventDefault()

        const targetOffset = $($(this).attr('href')).offset().top
        const headerHeight = $('#hongo-header .navbar').outerHeight()

        Sw.scrollToSection(targetOffset - headerHeight)
      })

      $(document).on('click', '.js-sw-modal-popup', function () {

        const modal = $('#sw-dynamic-popup')

        modal.find('.popup-title').html($(this).data('popup_title'))
        modal.find('.popup-content').html($(this).data('popup_content'))
      })

      $(document).on('click', '.js-sw-redirect-to-cart', function () {

        window.location = $(this).data('href')
      })

      $(document).on('click', '.js-sw-close-mini-cart', function () {

        $('span[data-cart-notification-close]').click()
      })

      $(document).on('click', '.js-sw-open-mobile-menu', function (event) {

        event.stopPropagation()
        event.preventDefault()

        $('#navbarNav').collapse('toggle')
      })

      $(document).on('click', '.js-sw-button-buy-now', function () {

        var variantId = $(this).data('variant_id');
        var quantity = $(this).data('quantity');

        $.ajax({
          url: '/cart/clear.js',
          method: 'POST',
          dataType: 'json',
          success: function () {

            $.ajax({
              url: '/cart/add.js',
              method: 'POST',
              contentType: 'application/json',
              data: JSON.stringify({
                items: [
                  {
                    id: variantId,
                    quantity: quantity,
                  },
                ],
              }),
              success: function () {
                window.location.href = '/checkout';
              },
              error: function () {
                alert('Failed to add the product to the cart. Please try again.');
              },
            });
          },
          error: function () {
            alert('Failed to clear the cart. Please try again.');
          },
        });
      })

      $(document).on('click', '.product-form .notify-me', function (e) {

        e.preventDefault()
      })
      
      $(document).on('click', '.js-sw-canvas-open-mobile-menu a', function (e) {
        
        e.preventDefault();
        
        $('.navbar-collapse .navbar-collapse-header .horizontal-menu-list').removeClass('active');
        $('.navbar-collapse .navbar-collapse-header .vertical-menu-list').addClass('active');
        $('.navbar-collapse .vertical-navbar-list').show();
        $('.navbar-collapse .navbar-nav').hide();
      });
      
      $(document).on('click', '.navbar-collapse .navbar-collapse-header .vertical-menu-list', function (e) {
        
        e.preventDefault();
        e.stopPropagation();
        
        setTimeout(function () {
          $('.navbar-collapse .navbar-collapse-header .horizontal-menu-list').addClass('active');
          $('.navbar-collapse .navbar-collapse-header .vertical-menu-list').removeClass('active');
          $('.navbar-collapse .vertical-navbar-list').hide();
          $('.navbar-collapse .navbar-nav').show();
        }, 50)
      });

      $(document).on('click', '.cart-notification-product .remove', function () {

        const giftProductsProgress = $(this).closest('#cart-notification').find('.js-sw-gift-products-progress')
        const idGiftVariants = Array.isArray(giftProductsProgress.data('id_gift_variants'))
          ? giftProductsProgress.data('id_gift_variants').map(Number)
          : String(giftProductsProgress.data('id_gift_variants')).split(',').map(id => Number(id.trim()));
        const idVariant = $(this).data('item-id')

        if (idGiftVariants.includes(idVariant)) {
          sessionStorage.setItem('giftDeclined', 'true');
        }
      })

      $('.cart-notification-product .quantity-button.quantity-minus').click(function () {

        const giftProductsProgress = $(this).closest('#cart-notification').find('.js-sw-gift-products-progress')
        const idGiftVariants = Array.isArray(giftProductsProgress.data('id_gift_variants'))
          ? giftProductsProgress.data('id_gift_variants').map(Number)
          : String(giftProductsProgress.data('id_gift_variants')).split(',').map(id => Number(id.trim()));
        const idVariant = $(this).closest('.cart-notification-product').find('.remove').data('item-id')

        if (idGiftVariants.includes(idVariant)) {
          sessionStorage.setItem('giftDeclined', 'true');
        }
      })

      Sw.cart.cartChangeEvent()
      Sw.global.toggleHTMLOverflow()
    },
    
    toggleHTMLOverflow: () => {
      
      const page = $('html')
      const observer = new MutationObserver(() => {
        
        $('body').hasClass('search-active') ? page.addClass('search-active') : page.removeClass('search-active')
      });
      
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    }
  },

  product: {

    init: () => {

      console.log('Sw.product.init')

      Sw.product.reviews.init()

      $(document).on('click', '.product-summary .product-rating', function () {
        
        const targetOffset = $('#judgeme_product_reviews').offset().top
        const headerHeight = $('#hongo-header .navbar').outerHeight()

        Sw.scrollToSection(targetOffset - headerHeight)
      })
    },

    reviews: {

      featuredBox: '.col.testimonial-style-01',

      init: () => {

        const featuredReviewContainer = $('#sw_js_featured_review')
        const featuredReviewsSection = $('#sw_js_featured_reviews_section')

        featuredReviewContainer.length && Sw.product.reviews.getRandomFeaturedReview(featuredReviewContainer.selector)

        featuredReviewsSection.length && Sw.product.reviews.populateFeaturedReviewsSection(featuredReviewsSection)
      },

      getRandomFeaturedReview: container => {

        console.log('Sw.product.reviews.getRandomFeaturedReview')

        const reviews = $('#judgeme_product_reviews .jdgm-rev__rating[data-score="5"]')

        if (reviews.length) {

          const randomReviewIndex = Math.floor(Math.random() * reviews.length)
          const review = reviews.eq(randomReviewIndex).closest('.jdgm-rev')

          review.clone().appendTo(container)

          if (reviews.length > 1) {

            const button = $('<div>', { class: 'jdgm-rev-button' }).append(
              $('<a>', {
                href: '#judgeme_product_reviews',
                class: 'js-scroll-to-section btn btn-very-small btn-link btn-link-black',
                text: $(container).data('button_text')
              })
            )
            button.appendTo(container)
          }
        }
      },

      populateFeaturedReviewsSection: container => {

        const reviews = $('#judgeme_product_reviews .jdgm-rev__rating[data-score="5"]').slice(0, 3)
        const averageReviews = $('#judgeme_product_reviews .jdgm-rev-widg__summary-stars')
        const reviewContainers = container.find(Sw.product.reviews.featuredBox)

        reviews.each((key, review) => {
          Sw.product.reviews.setFeaturedReview($(review).closest('.jdgm-rev'), reviewContainers.eq(key))
        })

        const hiddenReviews = reviewContainers.not('[data-sw_appended]')

        container.find('.testimonial-title .image').html(averageReviews)

        hiddenReviews.each((_, review) => $(review).remove())



        hiddenReviews.length === 3 ? container.remove() : container.removeClass('is-hidden')
      },

      setFeaturedReview: (review, container) => {

        const title = review.find('.jdgm-rev__title').text()
        const text = review.find('.jdgm-rev__body p').text()
        const rating = review.find('.jdgm-rev__rating').html()
        const author = review.find('.jdgm-rev__author').text()
        const icon = review.find('.jdgm-rev__icon')

        title.length ? container.find('.title').text(title) : container.find('.title').remove()
        text.length && container.find('.box-inner > p').text(text)
        rating.length && container.find('.rating').replaceWith(rating)
        author.length && container.find('.author-name').text(author)
        icon.length && container.find('.author > svg').replaceWith('<div class="jdgm-rev__icon"></div>')

        container.attr('data-sw_appended', '1')
      }
    },
  },

  sections: {

    init: () => {

      console.log('Sw.sections.init')

      const featuredBlogsContainer = $('.sw-featured-blog-all')
      const featuredProductTab = $('.sw-featured-product-tab')

      if (featuredBlogsContainer.length) {

        Sw.blog.filterBlogArticles(featuredBlogsContainer, 1)
      }

      if (featuredProductTab.length) {

        $(document).on('click', '.sw-featured-product-tab button', (event) => {

          const self = $(event.currentTarget)
          const collectionUrl = self.data('collection_url')
          const collectionTitle = self.data('collection_title')

          self.closest('.row').find('a').attr('href', collectionUrl)
          self.closest('.row').find('h3').text(collectionTitle)
        })

        $('.sw-featured-product-tab button').first().click()
      }
    }
  },

  cart: {

    rate: Shopify.currency.rate || '1.0',

    isUpdatingGiftProducts: false,

    init: () => {

      console.log('Sw.cart.init')

      const giftProductsProgress = $('.js-sw-gift-products-progress')

      if (giftProductsProgress.length) {

        const idGiftVariants = Array.isArray(giftProductsProgress.data('id_gift_variants'))
          ? giftProductsProgress.data('id_gift_variants').map(Number)
          : String(giftProductsProgress.data('id_gift_variants')).split(',').map(id => Number(id.trim()));

        $(document).on('click', '.cart-item .product-remove cart-remove-button', function () {

          const idVariant = $(this).data('item-id')

          if (idGiftVariants.includes(idVariant)) {
            sessionStorage.setItem('giftDeclined', 'true');
          }
        })

        $('.cart-item .cart-item-quantity .quantity-button.quantity-minus').click(function () {

          const idVariant = $(this).closest('.cart-item').find('cart-remove-button').data('item-id')

          if (idGiftVariants.includes(idVariant)) {
            sessionStorage.setItem('giftDeclined', 'true');
          }
        })
      }
    },

    cartChangeEvent: () => {

      (function(ns, fetch) {

        if (typeof fetch !== "function") return;

        ns.fetch = function() {

          const response = fetch.apply(this, arguments)

          response.then(res => {

            // let path = Shopify.locale !== 'bg-BG' ? `${window.location.origin + '/' + Shopify.locale}/cart.js` : `${window.location.origin}/cart.js`
            let path = `${window.location.origin + window.Shopify.routes.root}cart.js`

            if ([path,].includes(res.url)) {
              res.clone().json().then((cart) => cart.items.length && Sw.cart.onCartUpdate(cart));
            }
          });

          return response
        };

      }(window, window.fetch))
    },

    onCartUpdate: cart => {

      console.log('Sw.cartChangeEvent')
      
      Sw.cart.updateIncrementalDiscount(cart)
      Sw.cart.updateGiftProducts(cart)
    },

    updateIncrementalDiscount: cart => {

      console.log('Sw.cart.updateIncrementalDiscount')

      const container = $('.js-sw-incremental-discounts')
      let remainingAmount = 0

      if (container.length) {

        if (cart.items.length > 0) {

          container.addClass('is-loading');

          let prevPrices = 0;
          let barWidth = 0;

          container.find('.js-sw-progress-dots').each((key, discount) => {

            const rate = parseFloat(Sw.cart.rate)
            const baseMinAmount = Number($(discount).data('min_amount'))
            const minAmount = baseMinAmount * rate
            const idProducts = $(discount).data('id_products')
            let totalAmount = 0

            $.each(cart.items, (key, item) => {
              if (idProducts) {
                idProducts.includes(item.product_id) ? totalAmount = totalAmount + item.original_line_price : ''
              } else {
                totalAmount = totalAmount + item.original_line_price;
              }
            })

            let progress = ((totalAmount / minAmount) * 100)
            progress >= 100 ? progress = 100 : ''

            totalAmount >= minAmount ? $(discount).addClass('is-active') :  $(discount).removeClass('is-active')

            if (key <= container.find('.js-sw-progress-dots.is-active').length) {

              barWidth = barWidth + (progress / container.data('count_discounts'))

              remainingAmount = (minAmount - totalAmount) / 100
            }
          })

          remainingAmount > 0 ? Sw.cart.setDiscountTitle(container, remainingAmount) : Sw.cart.setDiscountTitle(container, 0, 1)

          container.find('.js-sw-progress-bar').find('span').width(`${barWidth}%`)

          setTimeout(function () {
            container.removeClass('is-loading')
          }, 500);
        } else {

          container.addClass('d-none')
        }
      }
    },

    updateGiftProducts: cart => {

      console.log('Sw.cart.updateGiftProducts')

      const container = $('.js-sw-gift-products')
      let remainingAmount = 0

      if (container.length) {

        if (cart.items.length > 0) {

          container.addClass('is-loading');

          let progress = $('.js-sw-gift-products-progress');

          const rate = parseFloat(Sw.cart.rate)
          const baseMinAmount = Number(progress.data('min_amount'))
          const minAmount = baseMinAmount * rate
          const idProducts = progress.data('id_products')
          const idGiftVariants = Array.isArray(progress.data('id_gift_variants'))
            ? progress.data('id_gift_variants').map(Number)
            : String(progress.data('id_gift_variants')).split(',').map(id => Number(id.trim()));

          //const item = cart.items.find(i => i.key === itemKey);

          let totalAmount = 0

          $.each(cart.items, (key, item) => {
            if (idProducts) {
              idProducts.includes(item.product_id) ? totalAmount = totalAmount + item.final_line_price : ''
            } else {
              totalAmount = totalAmount + item.final_line_price;
            }
          })

          remainingAmount = (minAmount - totalAmount) / 100
          Sw.cart.remainingAmount = remainingAmount;

          const overCountGiftItems = cart.items.filter(
            item => idGiftVariants.includes(item.variant_id) && item.quantity > 1
          );

          if (overCountGiftItems.length > 0) {

            const corrections = overCountGiftItems.map(item => {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: item.key,
                  quantity: 1
                })
              }).then(res => res.json())
                .then(data => {
                  Sw.cart.updateCartSections(data);
                });
            });

            Promise.all(corrections)
              .then(() => {
                return fetch('/cart.js');
              })
              .then(res => res.json())
              .then(updatedCart => {
                Sw.cart.updateGiftProducts(updatedCart);
              });

            return;
          }

          if (remainingAmount > 0) {
            Sw.cart.setGiftProductsTitle(container, remainingAmount)
            Sw.cart.removeGiftProducts(cart.items, idGiftVariants)
          } else {
            Sw.cart.setGiftProductsTitle(container, 0)

            if (sessionStorage.getItem('giftDeclined') !== 'true') {
              Sw.cart.addGiftProducts(cart.items, idGiftVariants)
            }
          }

          setTimeout(function () {
            container.removeClass('is-loading');
          }, 500)
        } else {

          container.addClass('d-none')
        }
      }
    },

    setDiscountTitle: (container, amount, is_complete, cart_items) => {

      const progressTitle = container.find('.discount-text p')
      let text = container.data('success_message')

      if (amount) {

        const firstInactiveDiscount = container.find('.js-sw-progress-dots:not(.is-active)').first()
        const message = firstInactiveDiscount.data('message')
        const collection = firstInactiveDiscount.data('collection')
        const percentage = firstInactiveDiscount.data('percentage')
        const amountFormat = firstInactiveDiscount.data('amount_format')
        let amountFormated = amountFormat.replace('{{amount}}', Sw.cart.formatMoney(amount)).replace('{{amount_with_comma_separator}}', Sw.cart.formatMoney(amount, 1))

        if (typeof doubleCurrency !== 'undefined' && doubleCurrency.enabled && doubleCurrency.destination !== Shopify.currency.active) {

          const doublePrice = Math.round((amount * doubleCurrency.rate + Number.EPSILON) * 100) / 100;
          const doublePriceHTML = '<span class="double-currency-divider"> / </span><span class="money">' + doublePrice.toFixed(2) + ' ' + doubleCurrency.symbol + '</span>';

          amountFormated = amountFormated + doublePriceHTML;
        }

        text = message.replace('%collection%', collection).replace('%percentage%', percentage).replace('%amount%', amountFormated)
      }

      progressTitle.html(text)

      is_complete ? Sw.cart.showConfetti() : Sw.cart.removeConfetti()
    },

    setGiftProductsTitle: (container, amount, is_complete, cart_items) => {

      const progressTitle = container.find('.gift-products-text p')

      let text = container.data('success_message')

      if (amount) {

        const firstInactiveDiscount = container.find('.js-sw-gift-products-progress')
        const message = firstInactiveDiscount.data('message')
        const collection = firstInactiveDiscount.data('collection')
        const title = firstInactiveDiscount.data('title')
        const amountFormat = firstInactiveDiscount.data('amount_format')
        let amountFormated = amountFormat.replace('{{amount}}', Sw.cart.formatMoney(amount)).replace('{{amount_with_comma_separator}}', Sw.cart.formatMoney(amount, 1))

        if (typeof doubleCurrency !== 'undefined' && doubleCurrency.enabled && doubleCurrency.destination !== Shopify.currency.active) {

          const doublePrice = Math.round((amount * doubleCurrency.rate + Number.EPSILON) * 100) / 100;
          const doublePriceHTML = '<span class="double-currency-divider"> / </span><span class="money">' + doublePrice.toFixed(2) + ' ' + doubleCurrency.symbol + '</span>';

          amountFormated = amountFormated + doublePriceHTML;
        }

        text = message.replace('%collection%', collection).replace('%title%', title).replace('%amount%', amountFormated)
      }

      progressTitle.html(text)
    },

    showConfetti: () => {

      if("shipping_animated" in localStorage){}else{
        (async () => {
          await loadConfettiPreset(tsParticles);
          tsParticles.load("tsparticles", {
            fullScreen: {
              enable: false
            },
            particles: {
              color: {
                value: ['#EF2964', '#00C09D', '#2D87B0', '#48485E', '#EFFF1D'],
              },
              shape: {
                type: ["circle", "square", "triangle"]
              },
              move: {
                direction: "top",
                enable: true,
                outModes: {
                  top: "none",
                  default: "destroy"
                },
                gravity: {
                  enable: true
                },
                speed: 80
              },
              number: {
                value: 0,
                limit: 300
              },
              size: {
                value: { min: 4, max: 6 },
                animation: {
                  count: 5,
                  startValue: "min",
                  enable: true,
                  speed: 50,
                  sync: true
                }
              },
              tilt: {
                direction: "random",
                enable: true,
                value: {
                  min: 0,
                  max: 450
                },
                animation: {
                  enable: true,
                  speed: 300
                }
              }

            },
            emitters: [
              {
                life: {
                  duration: 3,
                  count: 1,
                },
                position: {
                  x: 50,
                  y: 0,
                },
                particles: {
                  move: {
                    direction: "top-bottom",
                  },
                },
                rate: {
                  quantity: 10,
                  delay: 0.1
                },
                size: {
                  width: 0,
                  height: 0
                }
              }
            ],
            preset: "confetti",
          });
        })();
      }
      localStorage.setItem('shipping_animated', 'yes');
      $("#cart-notification").prepend("<div id='tsparticles'></div>");
      setTimeout(function(){
        $("#tsparticles").remove()
      },7000)
    },

    removeConfetti: () => {

      $("#tsparticles").remove()
      localStorage.removeItem("shipping_animated");
    },

    addGiftProducts: (cart_items, idGiftVariants) => {

      if (Sw.cart.isUpdatingGiftProducts) return;
      Sw.cart.isUpdatingGiftProducts = true;

      const cartVariantIds = cart_items.map(item => item.variant_id);
      const variantsToAdd = idGiftVariants.filter(id => !cartVariantIds.includes(id));

      const items = variantsToAdd.map(variantId => ({
        id: variantId,
        quantity: 1
      }))
      
      if (variantsToAdd.length === 0) {
        Sw.cart.isUpdatingGiftProducts = false;
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
        .then(res => res.json())
        .then(data => {
          Sw.cart.updateCartSections(data);
        })
        .finally(() => {
          setTimeout(() => { Sw.cart.isUpdatingGiftProducts = false; }, 500);
        });
    },

    removeGiftProducts: (cart_items, idGiftVariants) => {

      if (Sw.cart.isUpdatingGiftProducts) return;

      Sw.cart.isUpdatingGiftProducts = true;

      const variantsToRemove = cart_items.filter(item => idGiftVariants.includes(item.variant_id));

      if (variantsToRemove.length === 0) {
        sessionStorage.removeItem('giftDeclined');
        Sw.cart.isUpdatingGiftProducts = false;
        return;
      }

      const updates = {};
      variantsToRemove.forEach(item => {
        updates[item.key] = 0;
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      })
        .then(res => res.json())
        .then(data => {
          Sw.cart.updateCartSections(data);
        })
        .finally(() => {
          setTimeout(() => {
            Sw.cart.isUpdatingGiftProducts = false;
          }, 500);
        });
    },

    formatMoney: (amount, comma) => {

      const currency = Shopify.currency.active || "BGN"
      const newAmount = amount.toLocaleString(currency, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })

      if (comma) {
        return newAmount.replace('.', ',')
      }

      return newAmount
    },

    updateCartSections: () => {

      const cartNotification = document.querySelector('cart-notification');

      if(cartNotification != null){

        fetch(`${window.Shopify.routes.root}?sections=cart-notification-content,cart-notification-crosssell-products`)
          .then((response) => response.json())
          .then((parsedState) => {
            const parsedStateSections = parsedState;
            cartNotification.updateContent(parsedStateSections);
          })
      } else{
        fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json()).then((parsedState) => {
          window.initFreeshippingGoal(parsedState);
          window.cartCount(parsedState);
          window.CartRenderSection(parsedState);
        })
      }
    }
  },

  scrollToSection: offset => $('html, body').animate({scrollTop: offset}, Sw.scrollDelay)
}

$(document).ready(function () {
  Sw.init()
})